import React from "react";
import { useTranslation } from "react-i18next";
import { ChartBarIcon } from "@heroicons/react/24/outline";
import DashboardHeader from "../../../../../components/dashboard/dashboardHeader";

/**
 * HSE/KS KPI Measurement Edit - Create new measurement
 */
export const HseKsKpiMeasurementEdit = () => {
  const { t } = useTranslation();

  return (
    <DashboardHeader
      title="Ny måling"
      subtitle="Målingsskjema"
    >
      <div className="mx-auto mt-8 grid max-w-3xl grid-cols-1 gap-6 sm:px-6 lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-3">
        <div className="space-y-6 lg:col-span-3 lg:col-start-1 sm:col-span-3">
          <div className="bg-white shadow sm:rounded-lg">
            <div className="px-4 py-5 sm:p-6">
              <p className="text-gray-500">Målingsskjema kommer snart...</p>
            </div>
          </div>
        </div>
      </div>
    </DashboardHeader>
  );
};

